<template>
    <div>
        <slot v-bind="this" :data="$data" :item="value" />
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    export default {
        props: {
            value: Object,
        },
        data() {
            return {
                date: this.value?.starts_at
                    ? dayjs(this.value.starts_at).toDate()
                    : null,
                hours: dayjs(this.value?.starts_at ?? undefined).hour(),
                minutes: this.value?.starts_at
                    ? dayjs(this.value.starts_at).minute()
                    : 0,
                hasCustomRoom: this.value.room_name,
            }
        },
        computed: {
            // time() {
            //     return this.date
            //         ? dayjs(this.date).format('HH:mm:ss')
            //         : null;
            // },
        },
        methods: {
            handleCustomRoomChanged(custom) {
                this.hasCustomRoom = custom;
                this.value.venue_room_id = null;
                this.value.room_name = '';
                this.value.room_city = '';
                this.value.room_department = '';
            },
            // handleHourChanged(e) {
            //     this.date = dayjs(this.date ?? undefined)
            //         .hour(Number(e.target.value))
            //         .toDate();
            // },
            // handleMinuteChanged(e) {
            //     this.date = dayjs(this.date ?? undefined)
            //         .minute(Number(e.target.value))
            //         .toDate();
            // },
            // handleDateChanged(value) {
            //     const date = dayjs(value);
            //     this.date = dayjs(this.date ?? undefined)
            //         .date(date.date())
            //         .month(date.month())
            //         .year(date.year())
            //         .toDate();
            // },
        },
    }
</script>